import Request from './request';
import consts from "@/consts.js";


async function fetch(data) {
    if (!data) data = {};
    return Request('get', "api/materials/index", Object.assign({},data,{
        itemsPerPage: consts.limitAll,
        limit: consts.limitAll,
    }));
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "material_code", "material_name", "Standard.name", "category_code", "MaterialCategory.name", "public_flg"]; // 仅筛选少许必要字段
    return Request('get', "api/materials/get-materials", data, false, false, true);
}

async function fetchFiledSelects(data) {
    return Request('get', "api/materials/get-filed-selects", data);
}

export default {
    fetch,
    fetchAllForSelect,
    fetchFiledSelects,
};